"use client";

import { ComponentProps } from "react";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import { useLocale } from "next-intl";
import { enUS, it } from "date-fns/locale";
import { format } from "date-fns";

export type CalendarProps = ComponentProps<typeof DayPicker>;

const localesMap = { en: enUS, it };

function Calendar({
  classNames,
  captionLayout,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  const locale = useLocale().split("-")[0] as keyof typeof localesMap;
  const selectedLocale = localesMap[locale] || enUS;
  const defaultClassNames = getDefaultClassNames();

  return (
    <DayPicker
      captionLayout={captionLayout}
      showOutsideDays={showOutsideDays}
      formatters={{
        formatCaption: (date, options) => format(date, "yyyy", options),
      }}
      classNames={{
        ...defaultClassNames,
        ...classNames,
      }}
      locale={selectedLocale}
      {...props}
    />
  );
}

Calendar.displayName = "Calendar";

export { Calendar };
